"use client"
import { useI18n } from '@/i18n/client'
export function CookiePreferencesButton(){
 const {locale}=useI18n()
 return <button type="button" onClick={()=>window.dispatchEvent(new Event('danaro-cookie-preferences'))}>{locale==='es'?'Preferencias de cookies':'Cookie preferences'}</button>
}
